documentReady(function($, Lum) {

    /* init js functions here: */

    //ajax live search function for the header search bar
    ajaxLiveSearch();


    //ajax load more posts
    ajaxLoadMorePosts();


    loadSubscribeModal();
    $(window).on('load unload beforeunload scroll', loadSubscribeModal);


    $('.eventLayerTrigger').on('click', function (e) {
        e.preventDefault();
        var category = $(this).attr('data-category');
        var action = $(this).attr('data-action');
        var label = $(this).attr('data-label');
        var value = $(this).attr('data-value');
        var open_link = $(this).attr('data-open-link');
        var target = $(this).attr('target')===undefined ? '_self' : $(this).attr('target');

        addToDataLayer(category, action, label, value);
        
        if(open_link){
            window.open($(this).attr('href'), target);
        }
    });
    
        
    function addToDataLayer(category, action, label, value) {
        if (typeof dataLayer == 'undefined') {
            console.warn('dataLayer not defined');
            return;
        }

        dataLayer.push({
            event: "Dynamic Event",
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
        });

    }

    setTimeout(function(){
        adjustRelatedPosts();
        initAjaxPosts();
    }, 300);
    $('.fade').addClass('loaded');
    $(window).on('load unload', function(){
        setTimeout(function(){
            initAjaxPosts();
        }, 300);
        $('.fade').addClass('loaded');
    });

    var resizeTimer;
    //revalidate blazy for hidden images when resizing
    $(window).on('resize', function(e) {
        adjustRelatedPosts()
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            Lum.bLazy.revalidate();
        }, 250);
    });


    function ajaxLiveSearch(){

        $('.js-search').on('click', function(e){
            e.preventDefault();
            $('.hdr-srch').addClass('active');
            $('.hdr-srch-results').html('');
            setTimeout(function(){
                $('#s').focus();
            }, 150);
        });

        //close the search bar in the header
        $('.js-search-close').on('click', function(e){
            e.preventDefault();
            closeSearchBar();
        });

        //Event when user is typing to do a live search
        $('.hdr-srch #s').on('keyup', function(e){

            //if the key is not arrow down then do the search
            if(e.which!==40){

                $.ajax({
                    url: ajax_url,
                    type: 'post',
                    dataType: 'html',
                    data: { action: 'wpb_ajax_fetch_search', keyword: $(this).val() },
                    success: function(data) {
                        if(data!==''){
                            $('.hdr-srch-results').addClass('has-results');
                        }else{
                            $('.hdr-srch-results').removeClass('has-results');
                        }
                        $('.hdr-srch-results').html(data);
                    }
                });

            }
            
        });


        $(document).keydown(function(e) {

            if($('.hdr-srch-results li').length>0){

                if([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                    e.preventDefault();
                }

                if(e.keyCode==40){

                    var current_focused = $('.hdr-srch-results li.focused');

                    if($('.hdr-srch-results li.focused').next().length===0){
                        $('.hdr-srch-results li').first().addClass('focused');
                        $('.hdr-srch-results li').first().find('a').focus();
                    }else{
                        $('.hdr-srch-results li.focused').next().addClass('focused');
                        $('.hdr-srch-results li.focused').next().find('a').first().focus();
                    }
                    
                    $(current_focused).removeClass('focused').blur();

                }else if(e.keyCode==38){

                    var current_focused = $('.hdr-srch-results li.focused');

                    if($('.hdr-srch-results li.focused').prev().length===0){
                        $('.hdr-srch #s').focus();
                    }else{
                        $('.hdr-srch-results li.focused').prev().addClass('focused');
                        $('.hdr-srch-results li.focused').prev().find('a').focus();
                    }

                    $(current_focused).removeClass('focused').blur();
                }

            }

        });


        $(document).click(function(e) {
            if ( $(e.target).closest('#s').length === 0 && $(e.target).closest('.js-search').length === 0 ) {
                closeSearchBar();
            }
            if ($(e.target).closest('.btn-mob').length === 0 && $(e.target).closest('.mobile-nav-wrap').length === 0 ) {
                $('body').removeClass('mobile-active').addClass('mobile-not-active');
            }
        });

        function closeSearchBar(){
            $('.hdr-srch').removeClass('active');
            $('.hdr-srch-results').removeClass('has-results');
            $('.hdr-srch-results').html('');
            $('#s').val('');
            $('.hdr-srch-results li').removeClass('focused').blur();
        }

    }


});


function adjustRelatedPosts(){
    if($('.related-posts').length>0){
        if($('.related-posts').find('.col-post-box').length>3){
            if($(window).outerWidth()<1199){
                $('.related-posts').find('.col-post-box').last().hide();
            }else{
                $('.related-posts').find('.col-post-box').last().show();
            }
        }
    }
}


function initAjaxPosts(){
    if($('.js-load-more').length!==0 && $('.js-load-more').attr('data-page')==0){
        if($(window).outerWidth()>0 && $(window).outerWidth()<768){
            $('.js-load-more').attr('data-num-posts', '4');
        }else if($(window).outerWidth()>768 && $(window).outerWidth()<1025){
            $('.js-load-more').attr('data-num-posts', '6');
        }else{
            $('.js-load-more').attr('data-num-posts', '8');
        }

        $('.js-load-more').trigger('click');
    }
}

function ajaxLoadMorePosts(){
    if($('.js-load-more').length>0){
        var load_more_news = false;
        $('.js-load-more').on('click', function(e){
            e.preventDefault();
            if(!load_more_news){
                load_more_news = true;
                var page = $(this).attr('data-page');
                var cat = $(this).attr('data-cat');
                var author = $(this).attr('data-author');
                var starting_offset = $(this).attr('data-starting-offset');
                var container = $(this).attr('data-container');
                var srch_query = $(this).attr('data-srch_query');
                var cat_no = $(this).attr('data-cat-not');
                var number_posts = $(this).attr('data-num-posts');
    
                var current_btn = $(this);
                var data = {
                    'action' : 'wpb_load_more_posts',
                    'page' : page,
                    'cat' : cat,
                    'author' : author,
                    's' : srch_query,
                    'category__not_in' : cat_no,
                    'starting_offset' : starting_offset,
                    'number_posts' : number_posts
                };
    
                if(page>0){
                    $(current_btn).css('opacity', '0.2');
                }
                
                
                $.ajax({
                    url: ajax_url,
                    data: data,
                    type: 'post',
                    dataType: 'json',
                    success: function (data) {
                        
                        console.log(data);
                        
                        if(data.error !== undefined || !data.next_posts){
                            $(current_btn).fadeOut(250, function(){
                                var current_btn_parent = (current_btn).parent();
                                $(current_btn_parent).html(data.error);
                                setTimeout(function(){
                                    $(current_btn_parent).fadeOut(500, function(){
                                        $(current_btn_parent).remove();
                                    });
                                }, 2000);
                            });
                        }
                        if(data.error === undefined){
                            $(current_btn).attr('data-page', data.page);
                            $(container).append(data.html);
                            setTimeout(function(){
                                Lum.bLazy.revalidate();
                                $(current_btn).css('opacity', '1');
                            }, 450);
                            Lum.bLazy.revalidate();
                        }
                        load_more_news = false;
                    },
                    complete: function(){
                        Lum.bLazy.revalidate();
                        $('.fade').addClass('loaded');
                    }
                });
            }
        });

    }
}



function loadSubscribeModal(){

    var subscribed = getCookie('subscribe_modal');
    var subscribed_session = sessionStorage.getItem("subscribe_modal_session");

    if(subscribed===null && subscribed_session===null && $(document).scrollTop()>200){
        $('.subscribe-modal').addClass('active');
    }

    $('.sbs-closeModal').on('click', function(e){
        setCookie('subscribe_modal', true, 30);
        sessionStorage.setItem("subscribe_modal_session", true);
        $('.subscribe-modal').removeClass('active');
    });

    $('.subscribe-button').on('click', function(e){
        setCookie('subscribe_modal', true, 30);
        sessionStorage.setItem("subscribe_modal_session", true);
    });

}

function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
}